/**
 * Ensures that an error is an actual instance of an error.
 *
 * - If it's null or undefined - a new Error with a dedicated message is
 *   returned.
 * - If it's an instance of an error - passed error is returned as is.
 * - If it's not an instance of an error - a new Error with a dedicated message
 *   is returned, containing the original stringified error.
 *
 * Unlike type assertion, you must use the newly returned value.
 *
 * This is a modified copy of ensureError() in @axinom/mosaic-service-common to avoid
 * dependencies.
 */
export const ensureError = (error: unknown): Error => {
  if (error === null || error === undefined) {
    return new Error('Unexpected null or undefined value received.');
  }
  if (error instanceof Error) {
    return error;
  }
  return new Error(
    `An error that is not an instance of an Error has been thrown: ${String(
      error,
    )}`,
  );
};
